import { jsx, Fragment } from "react/jsx-runtime";
import { GraphQlBuilder } from "@contember/client";
import { Component } from "./Component.js";
import { TreeNodeEnvironmentFactory } from "../dao/TreeNodeEnvironmentFactory.js";
import { useField } from "../accessorPropagation/useField.js";
import { MarkerFactory } from "../queryLanguage/MarkerFactory.js";
const Field = Component(
  (props) => {
    const field = useField(props);
    if (props.format !== void 0) {
      return /* @__PURE__ */ jsx(Fragment, { children: props.format(field.value) });
    }
    if (field.value instanceof GraphQlBuilder.GraphQlLiteral || field.value === null || typeof field.value === "boolean") {
      return null;
    }
    return /* @__PURE__ */ jsx(Fragment, { children: field.value });
  },
  {
    generateLeafMarker: (props, environment) => MarkerFactory.createFieldMarker(props, environment),
    generateEnvironment: (props, environment) => {
      return TreeNodeEnvironmentFactory.createEnvironmentForField(environment, props);
    }
  },
  "Field"
);
export {
  Field
};
//# sourceMappingURL=Field.js.map
